import { deleteCookie } from 'cookies-next';
import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

export function LogOut(){
    useEffect(() => {
        // Clear cookies
        deleteCookie('token');
        deleteCookie('rule');
        
        // Force page reload to ensure clean state
        window.location.href = '/';
    }, []);
    
    return (
        <Navigate to="/" replace />
    );
}